# Default Queue Conditions

Conditions can limit when a queue is played, when it stops playing, or how many times it plays.

Default queue conditions are applied by default to all queues that do not have specific conditions applied elsewhere.

If you set no conditions then the queue will always be valid.

## Standalone Queue Default Conditions

These are the default conditions applied to queues that are not nested inside another queue (i.e. they are the top level queues you see when you open a channel)

## Nested Queue Default Conditions

These are the default conditions applied to queues that are nested inside another queue (i.e. the parent of this queue is another queue and not a channel)
